import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";
import { Workshop } from "../Types/Product";

export const GetWorkshops = async (): Promise<ApiResponse<Workshop[]>> => {
  try {
    const response = await axiosClientv1.get(`/workshops/list`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load workshops.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const GetActiveWorkshops = async (): Promise<
  ApiResponse<Workshop[]>
> => {
  try {
    const response = await axiosClientv1.get(`/workshops/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load active workshops.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const CreateWorkshop = async (
  formData: Partial<Workshop>,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/workshops/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create workshop.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateWorkshop = async (
  formData: Partial<Workshop>,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/workshops/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update workshop.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteWorkshop = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/workshops/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete workshop.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const GetWorkshopById = async (
  id: string,
  delivery_date?: string | null,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/workshops/get_by_id`, {
      params: { id, delivery_date: delivery_date || undefined },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load workshop.",
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const ProcessWorkshopItem = async (payload: {
  workshop_id: string;
  item_id?: string;
  order_id?: string;
  product_id: string;
  source?: string;
  item_index?: number;
  quantity?: number;
  raw_material_id?: string | null;
  raw_material_stock_id?: string | null;
  cut_length_ft?: number;
  piece_count?: number;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/workshops/process-item`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to process item.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};
